import { render, staticRenderFns } from "./passe.vue?vue&type=template&id=639127b0"
import script from "./passe.vue?vue&type=script&lang=js"
export * from "./passe.vue?vue&type=script&lang=js"
import style0 from "./passe.vue?vue&type=style&index=0&id=639127b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports